<template>
    <main-layout>

        <app-header icon="bottle">
            Ajout bouteille
        </app-header>

        <nav id="actions-top" class="wrap" style="display: flex; justify-content: space-between">
            <router-link class="btn prev btn-full" :to="{name: 'liste-bouteilles'}">
                <i class="icon-go"></i>
                Retour
            </router-link>
            <slot></slot>

            <a v-if="urlAdmin !== undefined" class="btn btn-full" style="background-color: #393c51; width: 120px;padding: 0 9px;" @click.prevent="generatePopup()">
                Info bouteilles
            </a>
        </nav>



        <form class="wrap" @submit.prevent="sendForm">

            <label>CODE BOUTEILLE <span class="warning">{{ notifType }}</span> *</label>
            <a href="fi360://scan?success=fillCodeBarre&type=bouteille" class="btn btn-full" id="barcode-scan">SCAN CODE BARRE</a>
            <input title="code" placeholder="Code bouteille" type="text" v-model.trim="bouteille.code" maxlength="255">

            <div v-if="$route.query.key1 && $route.query.key2 && bouteille">
                <label>OTAG *</label>
                <input title="otag" type="text" :value="$route.query.key1 + '-' + $route.query.key2" readonly>
            </div>

            <label>TYPE DE BOUTEILLE *</label>
            <select v-model="bouteille.type" @change="changeType">
                <option selected disabled>Sélectionnez un type de bouteille</option>
                <option>Fluide frigorigène</option>
                <option>Récupération</option>
                <option>Transfert</option>
            </select>

            <label>DISTRIBUTEUR * OU MARQUE INSCRITE BOUTEILLE</label>
            <select v-model="bouteille.fournisseur">
                <option selected disabled>Sélectionnez un fournisseur</option>
                <option v-for="fournisseur in fournisseurs" :key="fournisseur.id" :value="fournisseur">
                    {{ fournisseur.nom }}
                </option>
            </select>

            <label>MARQUE DE LA BOUTEILLE</label>
            <select v-model="bouteille.marque">
                <option :value="null">Aucune</option>
                <option v-for="marque in marques" :key="marque" :value="marque">
                    {{ marque }}
                </option>
            </select>

            <label>NOM BOUTEILLE *</label>
            <select v-model="bouteille.nom" @change="changeNomBouteille" id="nomBouteille">
                <option
                        class="opt-nombout"
                        v-for="n in noms_bouteille"
                        :key="n.id"
                        :value="n"
                        :class="[n.volume_max !== null ? '' : 'nomax', n.id === 53 ? 'bouteilleID53' : '']"
                        :data-id="n.id"
                >

                    {{ n.nom }}

                </option>
            </select>

            <label>FLUIDE FRIGORIGÈNE *</label>
            <select v-model="bouteille.fluide" ref="selecfluide">
                <option value="" disabled selected>Sélectionnez un fluide frigorigène</option>
                <option :value="0" ref="undefinedFluide" disabled>Indéfini</option>
                <option v-for="fluide in fluides" :key="fluide.id" :value="fluide" v-if="fluide.type !== 'CFC' && fluide.type !== 'HCFC' && fluide.nom !== 'R-999'">
                    {{ fluide.nom }}{{ (fluide.nom_commercial) ? ' - ' + fluide.nom_commercial : ''}}
                </option>
            </select>

            <label>POIDS NET* - QUANTITÉ DE FLUIDE CONTENU</label>
            <div v-if="recommandationPoids" style="margin-top: -8px; margin-bottom: 8px; font-size: 0.85rem; color: #999; font-style: italic;">
                Le distributeur préconise {{ recommandationPoids.poidNet }} kg, 
                <a href="#" @click.prevent="appliquerRecommandationPoids" style="color: #3490dc; text-decoration: underline; cursor: pointer; font-style: italic;">Cliquez pour remplir cette valeur !</a>
            </div>
            <input title="poidsNet" type="number" step="0.001" ref="poidsNet" v-model.number="bouteille.poids_net" @change="changePoidsNet" inputmode="decimal">

            <input type="hidden" v-model.number="bouteille.poids_max">

            <label>TARE - POIDS DE LA BOUTEILLE VIDE</label>
            <input title="tare" type="number" step="0.001" v-model.number="bouteille.tare" inputmode="decimal">

            <label>RÉFÉRENCE LIVRAISON</label>
            <input title="ref" type="text" v-model.trim="bouteille.ref_livraison">

            <label>DATE LIVRAISON *</label>
            <input title="dateLivraison" type="date" :max="now" v-model="bouteille.date_livraison" @change="calcRetour($event)">

            <label>DATE DE RETOUR PRÉVU *</label>
            <input title="dateRetour" type="date" :min="now" v-model="bouteille.date_retour_prevue" @change="setDateRetour($event)">

            <input type="submit" value="AJOUTER" :disabled="saving">
        </form>

    </main-layout>
</template>

<script>

import Bouteille from '../../js/models/Bouteille'
import Fluide from '../../js/models/Fluide'
import NomsBouteille from '../../js/models/NomBouteille'
import Fournisseur from '../../js/models/Fournisseur'
import Scan from '../../js/models/Scan'
import Config from '../../js/config'
import swal from "sweetalert2";
import localforage from "localforage";

export default {

        data() {
            return {

                bouteille: {
                    code: null,
                    key1: null,
                    key2: null,
                    type: null,
                    fournisseur: null,
                    marque: null,
                    nom: null,
                    fluide: null,
                    poids_net: null,
                    poids_max: null,
                    tare: null,
                    ref_livraison: null,
                    date_livraison: null,
                    date_retour_prevue: null,
                    created_at: null
                },

                fournisseurs: [],
                marques: Bouteille.MARQUES,
                noms_bouteille: [],
                fluides: [],
                notifType: '(Code barre conseillé)',
                urlAdmin: Config.urlAdmin,
                informationBouteille: [],
                saving: false
            }
        },

        methods: {
            async sendForm() {
                if (this.saving) {
                    return;
                }

                let bout = this.checkForm();

                if(bout !== false){
                    this.saving = true;

                    let checkCode, checkOtag;
                    try {
                        checkCode = await this.codeUsed(bout);
                        checkOtag = await this.otagUsed(bout);
                    } catch (err) {
                        this.saving = false;
                        throw err;
                    }

                    if(!checkCode  && !checkOtag ){

                        try {

                            let res = await Bouteille.addBouteille(bout);

                            if (this.$route.query.scan) {

                                try {

                                    await Scan.addOfflineScanBouteille(res);

                                    this.$router.push('liste-bouteilles');
                                    swal('Bouteille ajoutée', 'votre bouteille a bien été ajoutée', 'success')

                                } catch (err) {

                                    this.$router.push('liste-bouteilles');
                                    swal('Bouteille ajoutée', "votre bouteille a bien été ajoutée mais le scan position n'a pas fonctionné, vérifiez les permissions de l'application", 'success')

                                }


                            } else {

                                this.$router.push('liste-bouteilles');
                                swal('Bouteille ajoutée', 'votre bouteille a bien été ajoutée', 'success')

                            }

                        } catch (err) {
                            this.saving = false;
                            swal("Erreur d'ajout", "votre bouteille n'a pas été ajoutée", 'error')

                        }

                    } else {
                        this.saving = false;
                    }

                }

            },
            checkForm() {

                if (this.$route.query.key1 && this.$route.query.key2) {
                    this.bouteille.key1 = parseInt(this.$route.query.key1);
                    this.bouteille.key2 = parseInt(this.$route.query.key2);
                    this.bouteille.otag = `${this.$route.query.key1}-${this.$route.query.key2}`;
                }

                this.bouteille.created_at = moment().format('YYYY-MM-DD HH:mm:ss');

                let bout = Object.assign({}, this.bouteille);
                let errors = [];

                if (!bout.code) {
                    errors.push("le code")
                }
                if (!bout.type) {
                    errors.push("le type de bouteille")
                }
                if (!bout.fournisseur) {
                    errors.push("le distributeur")
                }
                if (!bout.nom) {
                    errors.push("le nom bouteille")
                }
                if (!bout.fluide && bout.type === 'Fluide frigorigène') {
                    errors.push("le fluide")
                }
                if (bout.poids_net === null || bout.poids_net === "") {
                    errors.push("le poids net")
                }
                if (bout.type === 'Fluide frigorigène' && bout.poids_net === 0){
                    errors.push('Une bouteille de fluide frigorigène ne peut pas avoir un poids net de 0Kg')
                }
                if (!bout.date_livraison) {
                    errors.push("la date de livraison")
                }
                if (!bout.date_retour_prevue) {
                    errors.push("la date de retour prévue")
                }

                if (errors.length !== 0) {

                    let txt = errors.join(', ');
                    swal('Information(s) manquante(s) :', 'Veuillez renseigner ' + txt + '.', 'error');
                    return false

                } else {

                    return bout

                }

            },

            async generatePopup() {
                let token = await localforage.getItem('api-token');

                let html = '';

                html = `
                        <style>
                            .pdf-button {
                                display: block;
                                padding: 12px 20px;
                                margin: 10px auto;
                                border: none;
                                background-color: #3490dc;
                                color: white;
                                font-size: 16px;
                                text-align: center;
                                border-radius: 8px;
                                text-decoration: none;
                                transition: background-color 0.3s ease;
                                width: 80%;
                                max-width: 300px;
                            }
                            .pdf-button:hover {
                                background-color: #2779bd;
                            }
                        </style>
                    `

                let listPdf = [
                    { "CALORIE FLUOR": "BOUTEILLES_CALORIE_FLUOR" },
                    { "CLIMALIFE": "BOUTEILLES_CLIMALIFE" },
                    { "COFRISET": "BOUTEILLES_COFRISET" },
                    { "ENTALPIA": "BOUTEILLES_ENTALPIA" },
                    { "FRAMACOLD": "BOUTEILLES_FRAMACOLD" },
                    { "FRITEC": "BOUTEILLES_FRITEC" },
                    { "GASCO": "BOUTEILLES_GASCO" },
                    { "GAZECHIM": "BOUTEILLES_GAZECHIM" },
                    { "ROLESCO": "BOUTEILLES_ROLESCO" },
                    { "WESTFALEN": "BOUTEILLES_WESTFALEN" }
                ];

                listPdf.forEach((element) => {
                    const [name, file] = Object.entries(element)[0];
                    html += `<a class="pdf-button" style="background-color: #393c51;" href="${this.urlAdmin}/tutorials/infoBouteille?token=${token}&name=${file}" target="_blank">${name}</a>`;
                })


                await swal({
                    title: 'Marques bouteilles',
                    showConfirmButton: false,
                    html
                })

            },

            async codeUsed(bout) {

                const _rawBouteilles = JSON.parse(await localforage.getItem('listBouteilles'));
                let codeUsed = (Array.isArray(_rawBouteilles) ? _rawBouteilles : []).filter(bouteille => {
                    if (bouteille.code.toUpperCase() === bout.code.toUpperCase() && bouteille.restitution === false) {
                        return bouteille
                    }
                });

                if(codeUsed.length !== 0){
                    swal('Code utilisé', "Ce code bouteille est déjà assigné à une bouteille non rendue", 'error')
                }

                return codeUsed.length !== 0

            },
            async otagUsed(bout){

                const _rawOtags = JSON.parse(await localforage.getItem('OTAGS'));
                let otagUsed = (Array.isArray(_rawOtags) ? _rawOtags : []).indexOf(bout.key1 + '-' + bout.key2);

                if(otagUsed !== -1){
                    swal('O-TAG utilisé', "Cet O-TAG a déjà été utilisé ("+bout.key1 + '-' + bout.key2+")", 'error')
                }

                return otagUsed !== -1

            },
            async initDefaultData() {

                let fournisseur = new Fournisseur;
                let noms = new NomsBouteille;
                let fluide = new Fluide;

                fluide.getListFiltre(data => this.fluides = data);
                noms.getList(data => this.noms_bouteille = data);
                fournisseur.getList(data => this.fournisseurs = data);

                // Charger les informations bouteille depuis localforage
                try {
                    const infoBouteilleData = await localforage.getItem('informationBouteille');
                    if (infoBouteilleData) {
                        this.informationBouteille = JSON.parse(infoBouteilleData);
                    }
                } catch (err) {
                    console.error('Erreur lors du chargement des informations bouteille:', err);
                }

                if (this.$route.query.key1 && this.$route.query.key2) {

                    this.bouteille.code = this.$route.query.key1 + this.$route.query.key2

                    if(typeof this.$route.query.type !== "undefined") {
                        this.bouteille.type = this.$route.query.type;


                        if(typeof this.$route.query.code != "undefined"){
                            this.bouteille.code = this.$route.query.code
                        }else if(this.bouteille.type !== "Fluide frigorigène"){
                            this.bouteille.code = null;
                        }

                        this.changeType();
                    }

                    if(typeof this.$route.query.wantScan !== "undefined"){
                        let btnScanCode = document.getElementById('barcode-scan');

                        btnScanCode.click()
                    }


                }

            },
            changeType() {
                let bouteilleID53 = document.querySelector('.bouteilleID53');

                if(bouteilleID53 === null){
                    setTimeout( () => {
                        let bt53 = document.getElementById('nomBouteille').getElementsByClassName('bouteilleID53');
                        bouteilleID53 = bt53[0];

                        if(this.bouteille.type === "Fluide frigorigène"){
                            bouteilleID53.style.display = 'none';

                            let boutmax = document.querySelectorAll('.opt-nombout.nomax');
                            _.forEach(boutmax, bout => {
                                bout.disabled = false;
                                bout.style.display = 'block'
                            })
                        } else {
                            bouteilleID53.style.display = 'block';

                            let boutmax = document.querySelectorAll('.opt-nombout.nomax');
                            _.forEach(boutmax, bout => {
                                bout.disabled = true;
                                bout.style.display = 'none'
                            })
                        }

                    },500)
                }

                if (this.bouteille.type === "Fluide frigorigène") {

                    this.$refs.undefinedFluide.disabled = true;
                    this.$refs.undefinedFluide.style.display = 'none';
                    this.bouteille.fluide = null;
                    this.$refs.selecfluide.disabled = false;
                    this.bouteille.poids_net = '';
                    this.bouteille.nom = null;
                    this.$refs.poidsNet.readOnly = false;

                } else {

                    this.$refs.undefinedFluide.disabled = false;
                    this.$refs.undefinedFluide.style.display = 'block';
                    this.bouteille.fluide = 0;
                    this.$refs.selecfluide.disabled = true;
                    this.bouteille.poids_net = 0;
                    this.bouteille.poids_max = null;
                    this.bouteille.nom = null;
                    this.$refs.poidsNet.readOnly = true;

                }

                if(bouteilleID53 != null){
                    if (this.bouteille.type === "Fluide frigorigène") {
                        bouteilleID53.style.display = 'none';

                        let boutmax = document.querySelectorAll('.opt-nombout.nomax');
                        _.forEach(boutmax, bout => {
                            bout.disabled = false;
                            bout.style.display = 'block'
                        })
                    } else {
                        bouteilleID53.style.display = 'block';

                        let boutmax = document.querySelectorAll('.opt-nombout.nomax');
                        _.forEach(boutmax, bout => {
                            bout.disabled = true;
                            bout.style.display = 'none'
                        })
                    }
                }
            },
            // Volume en litres extrait du nom de la bouteille, ou null si le nom
            // n'en contient pas. Accepte la virgule comme separateur decimal et
            // un espace avant le L.
            volumeDepuisNom(nom) {
                const trouve = (nom || '').match(/(\d+(?:[.,]\d+)?)\s*L/i);

                if (trouve === null) {
                    return null;
                }

                const volume = parseFloat(trouve[1].replace(',', '.'));

                return isNaN(volume) ? null : volume;
            },
            changePoidsNet() {
                if (this.bouteille.type === "Fluide frigorigène") {

                    // Le volume est dans le nom de la bouteille : "12,5L",
                    // "12,5L Cubikool", "26L Xlite", "930L". On capture le
                    // nombre lui-meme et non la chaine entiere : `match()[input]`
                    // renvoyait tout le nom, donc parseFloat ne tombait juste
                    // que pour un nom commencant par le chiffre.
                    const volume = this.volumeDepuisNom(_.get(this.bouteille, 'nom.nom', ''));

                    if (volume !== null && volume <= this.bouteille.poids_net) {
                        swal('Attention', 'Le poids renseigné ne semble pas être un poids Net de fluide !', 'info');
                    }

                    this.bouteille.poids_max = this.bouteille.poids_net
                }
            },
            changeNomBouteille() {
                if (this.bouteille.type !== "Fluide frigorigène" && _.has(this.bouteille.nom, 'volume_max')) {
                    this.bouteille.poids_max = this.bouteille.nom.volume_max
                }
            },
            calcRetour(event) {
                this.bouteille.date_livraison = event.target.value;

                if (!this.bouteille.date_retour_prevue && this.bouteille.type) {
                    let dateRetour = moment(this.bouteille.date_livraison);
                    if (_.includes(this.bouteille.type, 'Fluide')) {
                        dateRetour.add(12, 'month')
                    } else {
                        dateRetour.add(6, 'month')
                    }
                    this.bouteille.date_retour_prevue = dateRetour.format('YYYY-MM-DD')
                }
            },
            setDateRetour(event) {
                this.bouteille.date_retour_prevue = event.target.value;

                if (!this.bouteille.date_retour_prevue && this.bouteille.type) {
                    let dateRetour = moment(this.bouteille.date_livraison);
                    if (_.includes(this.bouteille.type, 'Fluide')) {
                        dateRetour.add(12, 'month')
                    } else {
                        dateRetour.add(6, 'month')
                    }
                    this.bouteille.date_retour_prevue = dateRetour.format('YYYY-MM-DD')
                } else if (this.bouteille.date_retour_prevue){
                    let dateRetour = moment(this.bouteille.date_retour_prevue);
                    this.bouteille.date_retour_prevue = dateRetour.format('YYYY-MM-DD')
                }
            },
            appliquerRecommandationPoids() {
                if (this.recommandationPoids && this.recommandationPoids.poidNet !== null && this.recommandationPoids.poidNet !== undefined) {
                    this.bouteille.poids_net = this.recommandationPoids.poidNet;
                    this.changePoidsNet();
                }
            }
        },

        mounted: function () {
            this.initDefaultData();
        },

        computed: {
            now: function () {
                return moment().format('Y-MM-DD')
            },
            recommandationPoids() {
                // Vérifier le type de bouteille en premier (on cherche seulement pour "Fluide frigorigène")
                if (!this.bouteille.type || this.bouteille.type !== 'Fluide frigorigène') {
                    return null;
                }
                
                // Vérifier que tous les autres champs nécessaires sont remplis
                if (!this.bouteille.fournisseur || 
                    !this.bouteille.nom || 
                    !this.bouteille.fluide ||
                    !Array.isArray(this.informationBouteille) ||
                    this.informationBouteille.length === 0) {
                    return null;
                }

                // Récupérer les valeurs à comparer
                const marque = this.bouteille.fournisseur.nom;
                const nomBouteille = this.bouteille.nom.nom;
                const fluideNom = this.bouteille.fluide.nom;
                // Détecter si c'est un fluide régénéré (format: "R-404A R - Régénéré" ou propriété regenerated)
                const isFluideRegenere = this.bouteille.fluide.regenerated === true || 
                                         (fluideNom && (fluideNom.includes('Régénéré') || fluideNom.includes('Régéné')));

                // Chercher une correspondance dans informationBouteille
                const correspondance = this.informationBouteille.find(info => {
                    // Comparer la marque (fournisseur)
                    const marqueMatch = info.marque && marque && 
                        info.marque.toUpperCase().trim() === marque.toUpperCase().trim();
                    
                    // Comparer le nom de bouteille
                    const nomMatch = info.nomBouteille && nomBouteille && 
                        info.nomBouteille.toUpperCase().trim() === nomBouteille.toUpperCase().trim();
                    
                    // Comparer le fluide (gérer les fluides régénérés)
                    let fluideMatch = false;
                    if (info.fluide && fluideNom) {
                        const infoFluideUpper = info.fluide.toUpperCase().trim();
                        const fluideNomUpper = fluideNom.toUpperCase().trim();
                        
                        // Fonction pour extraire le nom de base (enlever " R", "R", " R - Régénéré", etc.)
                        const getFluideBase = (fluide, isRegenere = false) => {
                            // Enlever " R - Régénéré" ou variantes
                            let base = fluide.replace(/\s+R\s*-\s*R[ÉE]G[ÉE]N[ÉE]R[ÉE]?/i, '').trim();
                            // Enlever " R" à la fin (avec espace)
                            base = base.replace(/\s+R$/i, '').trim();
                            // Si c'est un fluide régénéré, enlever le "R" final après une lettre/chiffre
                            // (ex: "R-404AR" -> "R-404A" pour fluide régénéré)
                            // Mais seulement si on sait que c'est régénéré, sinon on garde le nom tel quel
                            if (isRegenere) {
                                // Enlever R final après lettre/chiffre seulement pour fluides régénérés
                                base = base.replace(/([A-Z0-9])R$/i, '$1').trim();
                            }
                            return base;
                        };
                        
                        // Déterminer si info.fluide est régénéré (contient "R" à la fin après lettre/chiffre)
                        const infoIsRegenere = /[A-Z0-9]R$/i.test(infoFluideUpper);
                        
                        const fluideNomBase = getFluideBase(fluideNomUpper, isFluideRegenere);
                        const infoFluideBase = getFluideBase(infoFluideUpper, infoIsRegenere);
                        
                        // Correspondance exacte
                        fluideMatch = infoFluideUpper === fluideNomUpper;
                        
                        // Si pas de correspondance exacte, comparer les noms de base
                        if (!fluideMatch) {
                            fluideMatch = fluideNomBase === infoFluideBase && fluideNomBase !== '';
                        }
                    }
                    
                    // Vérifier que le typeBouteille correspond
                    // Pour fluide régénéré : "FLUIDE Régénéré" uniquement
                    // Pour fluide normal : "FLUIDE" mais pas "RÉGÉNÉRÉ"
                    let typeMatch = false;
                    if (info.typeBouteille) {
                        const typeBouteilleUpper = info.typeBouteille.toUpperCase();
                        
                        if (isFluideRegenere) {
                            // Pour fluide régénéré, chercher uniquement "FLUIDE Régénéré" (FLUIDE + RÉGÉNÉRÉ), "FLUIDE" seul, ou "TRANSFERT"
                            typeMatch = (typeBouteilleUpper.includes('FLUIDE') && typeBouteilleUpper.includes('RÉGÉNÉRÉ')) ||
                                       typeBouteilleUpper === 'FLUIDE' ||
                                       typeBouteilleUpper === 'TRANSFERT';
                        } else {
                            // Pour fluide normal, chercher "FLUIDE" mais pas "RÉGÉNÉRÉ"
                            typeMatch = typeBouteilleUpper.includes('FLUIDE') &&
                                       !typeBouteilleUpper.includes('RÉGÉNÉRÉ');
                        }
                    }
                    
                    const poidsNetOk = info.poidNet !== null && info.poidNet !== undefined;
                    
                    return marqueMatch && nomMatch && fluideMatch && typeMatch && poidsNetOk;
                });

                return correspondance || null;
            }
        }

    }

</script>

<style scoped="true">

     label span.warning {
         color: #c31616;
     }

    #barcode-scan{
        text-align: center;
        align-items: center;
        margin-bottom: 15px;
        font-size: 1.4rem;
    }

</style>



// WEBPACK FOOTER //
// NewBouteille.vue?3e99e843